/**
 * 株主優待モードの状態管理。
 *
 * 役割分担:
 * - 割引の適用そのもの … コード登録時にShopifyの割引Cookie（discount_code）へ
 *   保存され、チェックアウトではShopify自身が適用する。そのため別タブや
 *   セッション切れでも割引は維持される（page.yutai2026.liquid 参照）。
 * - ここで扱う「優待モードの表示状態」（適用中バー・カートの注意書き・
 *   対象外商品チェック）… 意図的にタブ単位（sessionStorage）で保持する。
 *   Cookieにすると購入完了後も最大14日間バナーが残り続けるため、
 *   表示系は永続化しない方針（2026-08 クライアント判断）。
 */
window.YutaiMode = (function () {
  // 一時期の実装が表示判定にも yutai_code Cookie を使っていたため、
  // その期間に配布されたCookieを掃除する（残っていても表示が復活しないように）
  document.cookie = 'yutai_code=; path=/; max-age=0; SameSite=Lax; Secure';

  function get() {
    try {
      return sessionStorage.getItem('code') || null;
    } catch (e) {
      return null;
    }
  }

  function set(code) {
    try {
      sessionStorage.setItem('code', code);
    } catch (e) {}
  }

  function clear() {
    // Shopify側に保存した割引クーポンも一緒に消す。
    // 残すと「表示は非優待モードなのにチェックアウトでは割引が付く」
    // という不整合が起きる。
    document.cookie = 'discount_code=; path=/; max-age=0';
    try {
      sessionStorage.removeItem('code');
    } catch (e) {}
  }

  return { get: get, set: set, clear: clear };
})();
